const cutText = (text: string, maxLength: number) => {
  const splitText = text.slice(0, maxLength).split(' ');
  return splitText.slice(0, splitText.length - 1).join(' ');
};

export default cutText;
